/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import VideoPlayerPositions from './VideoPlayerPositions'
import { gql, useMutation } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import { getIn } from '../utilities/utils';
import { pushMessage } from '../reducers/messagingReducer';
import { useDomainSettings } from '../hooks/useDomainSettings';
import { MULTI_FIELD_UPDATE_MUTATION } from '../mutations/mutations';

const VIDEO_POSITIONS_UPDATE_MUTATION = gql`
    mutation callUpdateVideoPlayerPositionsMutation($id: String, $positionList: String, $isPreset: Boolean, $isOverridingPreset: Boolean) {
        updateVideoPlayerPositionsMutation(input: {id: $id, positionList: $positionList, isPreset: $isPreset, isOverridingPreset: $isOverridingPreset}) {
            response
        }
    }
`

const DomainVideoPlayerPositions = () => {
    const dispatch = useDispatch()
    const DOMAIN_SETTINGS_MUTATION_CONTAINER = useDomainSettings()
    const [videoPositionUpdateMutationContainer] = useMutation(VIDEO_POSITIONS_UPDATE_MUTATION)
    const [multiFieldUpdateMutation] = useMutation(MULTI_FIELD_UPDATE_MUTATION)
    const [isOverridingPreset, setIsOverridingPreset] = useState(false)
    const { currentDomain, currentCustomer } = useSelector(state => state.userInformation)

    /** @type [Object[], React.Dispatch<React.SetStateAction<Object[]>>] */
    const [presetVideoPlayerPositions, setPresetVideoPlayerPositions] = useState([])
    /** @type [Object[], React.Dispatch<React.SetStateAction<Object[]>>] */
    const [domainVideoPlayerPositions, setDomainVideoPlayerPositions] = useState([])

    const [hasMutationCompleted, setMutationStatus] = useState(false)
    const [machineNames, setUsedMachineNames] = useState(new Set())
    const [presetId, setPresetId] = useState('')
    const [presetName, setPresetName] = useState('')
    const [playerVendor, setPlayerVendor] = useState('')

    useEffect(() => {
        if (currentCustomer && currentDomain) {
            DOMAIN_SETTINGS_MUTATION_CONTAINER({
                domainId: currentDomain,
                customerId: currentCustomer
            }).then(response => {
                let domainInfo = JSON.parse(getIn(response, 'data', 'domainEditMutation', 'customerInfo'))
                /** @type {Object[]} */
                let presetPositions = domainInfo.preset_video_player_positions || []
                /** @type {Object[]} */
                let domainPositions = domainInfo.domain_video_player_positions && domainInfo.domain_video_player_positions.length
                    ? domainInfo.domain_video_player_positions
                    : domainInfo.preset_video_player_positions;

                setPlayerVendor(domainInfo.player_vendor)
                setPresetVideoPlayerPositions(Array.isArray(presetPositions)
                    ? presetPositions.map(item => {
                        item.playerType = domainInfo.player_vendor
                        return item
                    })
                    : []
                )
                setDomainVideoPlayerPositions(
                    Array.isArray(domainPositions)
                        ? domainPositions.map(item => {
                            item.playerType = domainInfo.player_vendor
                            return item
                        })
                        : []
                )
                setIsOverridingPreset(!!domainInfo.override_video_player_positions)
                setUsedMachineNames(new Set(Object.values(domainPositions).map(i => i.displayName)))
                setPresetId(domainInfo?.adv_preset?.code)
                setPresetName(domainInfo?.adv_preset?.name)
                setMutationStatus(true)
            }).catch(err => {
                setMutationStatus(true)
                dispatch(pushMessage('Video player positions', 'Error querying domain information: ' + err.message, 'error'))
            })
        }
    }, [currentCustomer, currentDomain])

    return (
        <VideoPlayerPositions
            mode="domain"
            videoPlayerPositions={isOverridingPreset ? domainVideoPlayerPositions : presetVideoPlayerPositions}
            overridable={true}
            isOverridingPreset={isOverridingPreset}
            setOverridingStatus={status => setIsOverridingPreset(status)}
            setDomainVideoPlayerPositions={setDomainVideoPlayerPositions}
            presetName={presetName}
            usedMachineNames={machineNames}
            presetId={presetId}
            mutationCompleted={hasMutationCompleted}
            playerVendor={playerVendor}
            currentDomain={String(currentDomain)}
            saveHandler={() => {
                return videoPositionUpdateMutationContainer({
                    variables: {
                        id: `${currentDomain}`,
                        positionList: JSON.stringify(domainVideoPlayerPositions),
                        isPreset: false,
                        isOverridingPreset
                    }
                }).then(response => {
                    multiFieldUpdateMutation({
                        variables: {
                            rules: JSON.stringify([
                                {field_name: 'video_player_mode', post_id: String(currentDomain), value: playerVendor === 'brid_player' ? 'plugin' : 'inline', parse_value: false},
                                {field_name: 'video_player_type', post_id: String(currentDomain), value: playerVendor === 'brid_player' ? 'jwp_plugin' : 'jwp_embed', parse_value: false}
                            ])
                        }
                    })
                    return response
                }).catch(err => {
                    console.log('err: ', err.message)
                })
            }}
        />
    )
}

export default DomainVideoPlayerPositions